define('PressRoom/PressRoomListing',[
    "instantsearch", "jquery", "mustache",
    "text!LNRS/PressRoom/Templates/PressRoomListingTemplate.html",
    "text!LNRS/PressRoom/Templates/PressRoomGridTemplate.html",
    "moment", "hierarchicalmenuwidget", "matchHeight"
], function (instantsearch, $, mustache, pressRoomListingTemplate, pressRoomGridTemplate, moment, hierarchicalmenuwidget, matchHeight) {
    'use strict';

    function PressRoom(algoliaApiKey, algoliaIndexName, algoliaApplicationId, contextLanguage, isGrid, isPress, resultsId, pagingId, hitsPerPage, numberOfTiles,
        noResultsText, pagingNextLabel, pagingPreviousLabel, pressRoomTemplateId, newsTemplateId, readMoreLabel, showImage, industriesFilterLabel, industriesFilterId,
        solutionsFilterLabel, solutionsFilterId, yearsFilterLabel, yearsFilterId, hierarchicalFacetBaseName, hierarchicalFacetLevelBaseName, allPressReleases) {

        var languageFacet = "_language";
        var templateFacet = "_template";
        var industriesFilterIdSelector = '#' + industriesFilterId;
        var solutionsFilterIdSelector = '#' + solutionsFilterId;
        var yearsFilterIdSelector = '#' + yearsFilterId;

        var search = instantsearch({
            appId: algoliaApplicationId,
            apiKey: algoliaApiKey,
            indexName: algoliaIndexName,
            urlSync: false,
            searchParameters: {
                facets: [languageFacet, templateFacet],
                facetsRefinements: {
                    _language: [contextLanguage],
                    _template: isPress ? [pressRoomTemplateId] : [newsTemplateId]
                }
            }
        });

        var hierarchicalWidget = hierarchicalmenuwidget(
			algoliaApplicationId,
			algoliaApiKey,
			algoliaIndexName,
			contextLanguage,
			search,
			2,
			industriesFilterLabel,
			industriesFilterIdSelector,
            hierarchicalFacetBaseName,
			hierarchicalFacetLevelBaseName + "0",
			hierarchicalFacetLevelBaseName + "1",
            [getHierarchicalFacetName(hierarchicalFacetBaseName, hierarchicalFacetLevelBaseName, "0"), getHierarchicalFacetName(hierarchicalFacetBaseName, hierarchicalFacetLevelBaseName, "1")],
            null,
            null,
            allPressReleases
		);

        search.addWidget(
            hierarchicalWidget.widget
        );

        search.addWidget(
            instantsearch.widgets.menu({
                container: solutionsFilterIdSelector,
                attributeName: 'solutions',
                sortBy: ['name:asc', 'count:desc'],
                autoHideContainer: false,
                templates: {
                    header: solutionsFilterLabel
                },
                collapsible: {
                    collapsible: true,
                    collapsed: true
                }
            })
        );

        search.addWidget(
            instantsearch.widgets.menu({
                container: yearsFilterIdSelector,
                attributeName: 'publication year',
                autoHideContainer: false,
                templates: {
                    header: yearsFilterLabel
                },
                collapsible: {
                    collapsible: true,
                    collapsed: true
                },
				sortBy: ['name:desc']
            })
        );

        search.addWidget(
			instantsearch.widgets.hits({
			    container: "#" + resultsId,
			    templates: {
			        item: isGrid ? pressRoomGridTemplate : pressRoomListingTemplate,
			        empty: "<div class='no-results'>" + noResultsText + "</div>"
			    },
			    transformData: {
			        item: function (hit) {
			            if (hit["_news_date"]) {
			                var day = moment(hit["_news_date"], "YYYY-MM-DD");
			                hit["_news_date"] = day.isValid() ? day.format(getDateFormat()) : null;
			            }

			            hit["isNews"] = !isPress;
			            hit["read more label"] = readMoreLabel;
			            hit["showImage"] = showImage;
			            if (isPress) {
			                hit["_press_link"] = hit["url"];
			            }
			            else {
			                var url = "#";

			                if (hit["link"]) {
			                    var urlRaw = hit["link"].replace(/'/g, '"');
			                    url = urlRaw ? urlRaw.substring(urlRaw.indexOf("url") + 5, urlRaw.indexOf("\"", urlRaw.indexOf("url") + 5)) : "#";
			                }

			                hit["_press_link"] = url;
			            }

			            return hit;
			        }
			    },
			    //hitsPerPage: hitsPerPage
			    hitsPerPage: isGrid ? numberOfTiles : hitsPerPage
			})
		);

        if (!isGrid) {
            addPaging();
        }

        var onRenderHandler = function () {

            $('.press-room-gridview-item, .press-room-listview-item').hover(
			function (e) {
			    e.preventDefault();

			    if ($(this).find('.press-room-listview-item-link').length) {
			        $(this).find('.press-room-listview-item-link').show();
			    }
			    if ($(this).find('.press-room-gridview-item-link').length) {
			        $(this).find('.press-room-gridview-item-link').show();
			    }

			},
			function (e) {
			    e.preventDefault();

			    if ($(this).find('.press-room-listview-item-link').length) {
			        $(this).find('.press-room-listview-item-link').hide();
			    }
			    if ($(this).find('.press-room-gridview-item-link').length) {
			        $(this).find('.press-room-gridview-item-link').hide();
			    }

			});

            $('.press-room-listview-item, .press-room-gridview-item').click(function (e) {
                e.preventDefault();
                var isNews;
                var url;

                if ($(this).find('.press-room-listview-item-link').length) {
                    isNews = $(this).find('.press-room-listview-item').data('isnews') || false;
                    url = $(this).find('.press-room-listview-item-link').prop('href');

                    if (url) {
                        if (isNews) {
                            $(this).find('.press-room-listview-item-link').click();
                        } else {
                            window.location = url;
                        }
                    }
                    else {
                        return false;
                    }
                }
                if ($(this).find('.press-room-gridview-item-link').length) {
                    isNews = $(this).find('.press-room-gridview-item').data('isnews') || false;
                    url = $(this).find('.press-room-gridview-item-link').prop('href');

                    if (url) {
                        if (isNews) {
                            $(this).find('.press-room-gridview-item-link').click();
                        } else {
                            window.location = url;
                        }
                    }
                    else {
                        return false;
                    }
                }
            });

            hierarchicalWidget.onRenderCallback();
            onSolutionFilterRender();
            onYearsFilterRender();

            //$('.press-room-gridview-item').matchHeight();
        };

        $(document).on("click", onDocumentClick);

        search.on('render', onRenderHandler);
        search.start();

		filterButtonCollapse();
		
        function onDocumentClick(e) {
            var target = $(e.target);
            var solutionsFacet = search.helper.state.hierarchicalFacetsRefinements['solutions'];
            var yearsFacet = search.helper.state.hierarchicalFacetsRefinements['publication year'];

            if (target.hasClass('ais-menu--header') && target.parent().hasClass('ais-root__collapsed')) {
                if (target.parent().parent().prop('id') === yearsFilterId && target.text() !== yearsFilterLabel) {
                    target.text(yearsFilterLabel);
                } else if (target.parent().parent().prop('id') === solutionsFilterId && target.text() !== solutionsFilterLabel) {
                    target.text(solutionsFilterLabel);
                }
            } else if (target.hasClass('ais-menu--header') && !target.parent().hasClass('ais-root__collapsed') && target.text() === yearsFilterLabel) {
                search.helper.clearRefinements('publication year');
                search.helper.search();

            } else if (target.hasClass('ais-menu--header') && !target.parent().hasClass('ais-root__collapsed') && target.text() === solutionsFilterLabel) {
                search.helper.clearRefinements('solutions');
                search.helper.search();

            } else {
                if (target.parent().parent().prop('id') === yearsFilterId) {
                    onYearsFilterRender();
                } else if (target.parent().parent().prop('id') === solutionsFilterId) {
                    onSolutionFilterRender();
                }
            }

            if (!target.parent(solutionsFilterIdSelector).length && !target.hasClass('ais-menu--header')) {
                if (!$(solutionsFilterIdSelector).find('.ais-menu').hasClass('ais-root__collapsed')) {
                    var solutionsHeaderContainer = $(solutionsFilterIdSelector).find('.ais-header');

                    if (solutionsFacet && solutionsFacet[0]) {
                        solutionsHeaderContainer.text(solutionsFacet[0]);
                    }

                    solutionsHeaderContainer.click();
                }
            }

            if (!target.parent(yearsFilterIdSelector).length && !target.hasClass('ais-menu--header')) {
                if (!$(yearsFilterIdSelector).find('.ais-menu').hasClass('ais-root__collapsed')) {
                    var yearsHeaderContainer = $(yearsFilterIdSelector).find('.ais-header');

                    if (yearsFacet && yearsFacet[0]) {
                        yearsHeaderContainer.text(yearsFacet[0]);
                    }

                    yearsHeaderContainer.click();
                }
            }
        }

        function addPaging() {

            var w = window.innerWidth;

            var paginationWidget = instantsearch.widgets.pagination({
                container: '#' + pagingId,
                showFirstLast: false,
                padding: w < 768 ? 1 : 3,
                labels: {
                    next: pagingNextLabel,
                    previous: pagingPreviousLabel
                },
                cssClasses: { root: "pagination" }
            });

            var container = $('#' + pagingId);
            var oldRender = paginationWidget.render;
            paginationWidget.render = function (params) {
                var currentState = params.results;

                oldRender.call(this, params);

                if (currentState.nbPages <= 1)
                    container.hide();
                else {
                    container.show();
                }
            };

            search.addWidget(paginationWidget);
        }

        function onSolutionFilterRender() {
            var facet = search.helper.state.hierarchicalFacetsRefinements['solutions'];

            var selectedValue = facet && facet[0] ?
				facet[0] :
				solutionsFilterLabel;

            var headerContainer = $(solutionsFilterIdSelector).find(".ais-header");
            headerContainer.text(selectedValue);

            disableDropdownIfNoOptions($(solutionsFilterIdSelector));
        }

        function onYearsFilterRender() {
            var facet = search.helper.state.hierarchicalFacetsRefinements['publication year'];

            var selectedValue = facet && facet[0] ?
				facet[0] :
				yearsFilterLabel;

            var headerContainer = $(yearsFilterIdSelector).find(".ais-header");
            headerContainer.text(selectedValue);

            disableDropdownIfNoOptions($(yearsFilterIdSelector));
        }

        function disableDropdownIfNoOptions(dropdownContainer) {
            var shouldDisable = dropdownContainer.find('.ais-menu--list').children().length === 0;
            dropdownContainer.toggleClass('press-room-listing-filter-disabled', shouldDisable);
        }

        function getDateFormat() {
            switch (contextLanguage) {
                case 'en-US':
                    return "MM/DD/YYYY";
                default:
                    return "DD/MM/YYYY";
            }
        }

        function getHierarchicalFacetName(hierarchicalFacetBaseName, hierarchicalFacetLevelBaseName, level) {
            return hierarchicalFacetBaseName + "." + hierarchicalFacetLevelBaseName + level;
        }
		
		function filterButtonCollapse(){
			$('.btn-filter').on('click', function(e) {
				e.preventDefault();
			});
			$('.score-left').off('click');
			if ($(window).width() < 992) {				
				$('.score-left').on('click', '.btn-filter', function(){
					$('.press-room-listing-filters').slideToggle();
				});
				$('.press-room-listing-filters').hide();
			}
		};		
    }

    return function initPressRoom(args) {
        return args.IsPageEditorEditing === true ? null : new PressRoom(
            args.AlgoliaApiKey,
            args.AlgoliaIndexName,
            args.AlgoliaApplicationId,
            args.ContextLanguage,
            args.IsGrid,
            args.IsPress,
            args.ResultsId,
            args.PagingId,
            args.HitsPerPage,
            args.NumberOfTiles,
            args.NoResultsText,
            args.PagingNextLabel,
            args.PagingPreviousLabel,
            args.PressTemplateId,
            args.NewsTemplateId,
            args.ReadMoreLabel,
			args.ShowImage,
            args.IndustriesFilterLabel,
            args.IndustriesFilterId,
            args.SolutionsFilterLabel,
            args.SolutionsFilterId,
            args.YearsFilterLabel,
            args.YearsFilterId,
            args.HierarchicalFacetBaseName,
            args.HierarchicalFacetLevelBaseName,
            args.AllPressReleases);
    };
});
